module.exports = __webpack_public_path__ + "static/media/Cognizant.565809d0.png";